module.exports = __webpack_public_path__ + "static/media/inspiron22winners.ffb8063a.png";